import { render, staticRenderFns } from "./MessageSkeleton.vue?vue&type=template&id=d24c455e&scoped=true"
import script from "./MessageSkeleton.vue?vue&type=script&lang=js"
export * from "./MessageSkeleton.vue?vue&type=script&lang=js"
import style0 from "./MessageSkeleton.vue?vue&type=style&index=0&id=d24c455e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24c455e",
  null
  
)

export default component.exports